var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8794 10.8324H12.0388C11.9732 10.8324 11.9185 10.8871 11.9185 10.9527V11.9184H2.07944V2.07773H11.9201V3.04336C11.9201 3.10898 11.9748 3.16367 12.0404 3.16367H12.881C12.9466 3.16367 13.0013 3.11055 13.0013 3.04336V1.47773C13.0013 1.21211 12.7873 0.998047 12.5216 0.998047H1.47944C1.21382 0.998047 0.999756 1.21211 0.999756 1.47773V12.5184C0.999756 12.784 1.21382 12.998 1.47944 12.998H12.5201C12.7857 12.998 12.9998 12.784 12.9998 12.5184V10.9527C12.9998 10.8855 12.9451 10.8324 12.8794 10.8324ZM13.1701 6.89961L10.9529 5.14961C10.8701 5.08399 10.7498 5.14336 10.7498 5.24805V6.43555H5.84351C5.77476 6.43555 5.71851 6.4918 5.71851 6.56055V7.43555C5.71851 7.5043 5.77476 7.56055 5.84351 7.56055H10.7498V8.74805C10.7498 8.85274 10.8716 8.91211 10.9529 8.84649L13.1701 7.09649C13.185 7.08479 13.1971 7.06985 13.2054 7.0528C13.2137 7.03574 13.218 7.01702 13.218 6.99805C13.218 6.97908 13.2137 6.96035 13.2054 6.9433C13.1971 6.92624 13.185 6.9113 13.1701 6.89961Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.bf14f3e007fa09042568aa4b567c6d8e.svg";
export { ForwardRef as ReactComponent };